module.exports = __webpack_public_path__ + "static/media/MichelinPromisePlan-transparent.dcbebe9e.svg";